const UUID4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const ASSET_ID = /^[0-9a-f]{24}$/i;
const HASH = /^[0-9a-f]{64}$/i;

export const draftStorageKey = (userId) => userId ? `sales-video-create:${userId}` : null;

export const readPendingDraft = (storage, key) => {
  if (!key) return null;
  try {
    const value = JSON.parse(storage.getItem(key));
    const body = value?.payload;
    if (value?.version !== 1 || !body || !UUID4.test(body.client_request_id) || !ASSET_ID.test(body.product_asset_id) ||
        (body.model_asset_id !== null && !ASSET_ID.test(body.model_asset_id)) || !HASH.test(value.product_hash) ||
        (value.model_hash !== null && !HASH.test(value.model_hash)) ||
        !["kie", "kie_grok"].includes(body.provider) || typeof body.model_key !== "string" || !body.model_key.trim() ||
        typeof body.product_description !== "string" || !body.product_description.trim()) return null;
    if (body.template_id != null && (typeof body.template_id !== "string" || !/^[a-z0-9][a-z0-9_-]{0,79}$/.test(body.template_id))) return null;
    // Restore only the draft fields supported by the API.
    return { version: 1, product_hash: value.product_hash, model_hash: value.model_hash, payload: {
      client_request_id: body.client_request_id, product_asset_id: body.product_asset_id, model_asset_id: body.model_asset_id,
      product_description: body.product_description, model_key: body.model_key, provider: body.provider,
      ...(body.template_id ? { template_id: body.template_id } : {}),
    } };
  } catch { return null; }
};

export const persistPendingDraft = (storage, key, receipt) => {
  if (!key) throw new Error("Sesi pengguna belum tersedia. Muat ulang sebelum membuat draft.");
  try { storage.setItem(key, JSON.stringify(receipt)); }
  catch { throw new Error("Permintaan draft belum dapat disimpan. Izinkan penyimpanan sesi lalu coba lagi."); }
};

export const newDraftRequestId = (cryptoApi = globalThis.crypto) => {
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (!cryptoApi?.getRandomValues) throw new Error("Browser belum dapat membuat ID permintaan. Gunakan koneksi HTTPS.");
  const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

export const imageFingerprint = async (file, cryptoApi = globalThis.crypto) => {
  if (!cryptoApi?.subtle) throw new Error("Browser belum dapat memvalidasi foto. Gunakan koneksi HTTPS.");
  const digest = await cryptoApi.subtle.digest("SHA-256", await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
};

export const sameDraftIntent = (receipt, intent) => Boolean(receipt &&
  receipt.product_hash === intent.product_hash && receipt.model_hash === intent.model_hash &&
  receipt.payload.product_description === intent.product_description && receipt.payload.model_key === intent.model_key &&
  (receipt.payload.template_id || "") === (intent.template_id || ""));
